function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from 'react';
import { Flex, HStack, Box, Text, Pressable, Menu, useTheme } from 'native-base';
import { Alert, Platform } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faHeart } from '@fortawesome/pro-solid-svg-icons';
import { faHeart as faHeartOutline } from '@fortawesome/pro-regular-svg-icons';
import FRNMenu from './reusables/FRNMenu';
import HandlePost from './HandlePost';
import { useAuthState } from '../../../context/auth';
import { useEnvState } from '../../../context/env';
import { topicsAPI, useTopicsDispatch } from '../../../context/topics';
import Confirm from './reusables/Confirm';
import { WATCHING_STATUS_LIST } from '../../Constants';
import MoreActions from '../common/MoreActions';
import { LANGUAGES } from '../../Constants';
const InteractionBar = ({
  topic,
  reply,
  forSingleTopicScreen,
  loadContents,
  updateTopicReplies,
  likedReplyIDs,
  addLikedReplyID,
  removeLikedReplyID,
  updateForceReloadTopics,
  sharedComment,
  updateTopicPost,
  navigation,
  parent,
  renderedLikeCount,
  setRenderedLikeCount,
  platformUser,
  trackForum
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const [watchingText, setWatchingText] = useState('');
  const [selectedLevel, setSelectedLevel] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const type = reply ? 'reply' : 'topic';
  const [liked, setLiked] = useState(false);
  const isReplyYours = type === 'reply' && reply.yours;
  const authState = useAuthState();
  const envState = useEnvState();
  const topicsDispatch = useTopicsDispatch();
  const isFirstPost = parent && parent === 'Topic';
  useEffect(() => {
    setInitialLikeDisplay();
    setInitialWatchingDisplay();
  }, [likedReplyIDs, selectedLevel, watchingText]);
  useEffect(() => {
    setInitialSelectedLevel();
  }, []);
  const setInitialLikeDisplay = () => {
    if (likedReplyIDs !== null && likedReplyIDs !== void 0 && likedReplyIDs.includes(reply.id)) {
      setLiked(true);
    } else {
      setLiked(false);
    }
    return true;
  };
  const setInitialWatchingDisplay = () => {
    setWatchingText(WATCHING_STATUS_LIST[selectedLevel].text);
  };
  const setInitialSelectedLevel = () => {
    if (topic && topic.details && topic.details.notification_level) {
      setSelectedLevel(topic.details.notification_level);
    } else if (topic && topic.notification_level) {
      setSelectedLevel(topic.notification_level);
    }
  };
  const toggleLike = async () => {
    if (liked) {
      await unlikeReply();
    } else {
      await likeReply();
    }
  };
  const likeReply = async () => {
    const response = await topicsAPI.likeReply(envState.base_url, authState.api_key, type, reply && reply.id);
    if (response === true || response.id) {
      addLikedReplyID(reply.id);
      setLiked(true);
      if (setRenderedLikeCount) setRenderedLikeCount(renderedLikeCount + 1);
    }
  };
  const unlikeReply = async () => {
    try {
      const response = await topicsAPI.unlikeReply(envState.base_url, authState.api_key, reply.id);
      if (response === true || response.id) {
        removeLikedReplyID(reply.id);
        setLiked(false);
        if (setRenderedLikeCount) setRenderedLikeCount(renderedLikeCount - 1);
      } else {
        let message = LANGUAGES.UNLIKE_TIME_LIMIT_EXCEEDED;
        if (Platform.OS === 'web') {
          return Confirm.alert(message);
        } else {
          return Alert.alert(message);
        }
      }
      //}
    } catch (err) {
      if (err === 'You are not permitted to view the requested resource.') {
        console.log(LANGUAGES.UNLIKE_TIME_LIMIT_EXCEEDED);
      }
      console.log('Error while handling unliking reply');
      return err;
    }
  };
  const handleWatching = async newSelectedValue => {
    const acceptedTypes = ['topic', 'reply'];
    const topicID = type === 'topic' ? topic === null || topic === void 0 ? void 0 : topic.id : reply === null || reply === void 0 ? void 0 : reply.topic_id;
    if (!acceptedTypes.includes(type)) {
      throw new Error('Error while updating notification level');
    }
    const res = await topicsAPI.setNotificationLevel(envState.base_url, authState.api_key, topicID, newSelectedValue);
    if (res && res.success && res.success === 'OK') {
      setSelectedLevel(newSelectedValue);
      setWatchingText(WATCHING_STATUS_LIST[newSelectedValue].text);
      topicsDispatch({
        type: 'SET_UPDATE_WATCHING_STATUS_TOPIC_TIMESTAMP',
        payload: Date()
      });
      return true;
    }
    throw new Error('Failed to update notification level.');
  };
  const boxBackground = sharedComment ? colors.reply.bg.highlight : colors.reply.bg.default;
  const likedColor = liked ? colors.interactionBar.liked.icon.active : colors.interactionBar.liked.icon.default;
  const watchingColor = watchingText !== WATCHING_STATUS_LIST[0].text ? colors.interactionBar.watching.icon.active : colors.interactionBar.watching.icon.default;
  const handleGoToTopic = () => {
    try {
      navigation.navigate('SingleTopic', {
        topicId: topic.id,
        likedReplyIDs,
        addLikedReplyID,
        removeLikedReplyID
      });
    } catch (e) {
      console.log('Unable to navigate to topic');
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    alignItems: 'left',
    justifyContent: 'space-between',
    bg: boxBackground,
    my: 2,
    px: 4
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 8,
    alignItems: "center"
  }, !isReplyYours && /*#__PURE__*/React.createElement(Pressable, {
    onPress: toggleLike
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: liked ? faHeart : faHeartOutline,
    color: likedColor
  }), ' ', /*#__PURE__*/React.createElement(Text, null, liked ? 'Liked' : 'Like'))), isFirstPost && /*#__PURE__*/React.createElement(FRNMenu, {
    isOpen: isMenuOpen,
    onOpen: () => setIsMenuOpen(true),
    onClose: () => setIsMenuOpen(false),
    trigger: triggerProps => /*#__PURE__*/React.createElement(Pressable, null, /*#__PURE__*/React.createElement(Flex, _extends({
      direction: 'row',
      alignItems: 'center'
    }, triggerProps), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: WATCHING_STATUS_LIST[selectedLevel].icon,
      color: watchingColor
    }), ' ', /*#__PURE__*/React.createElement(Text, {
      onPress: () => setIsMenuOpen(prevState => !prevState)
    }, watchingText)))
  }, WATCHING_STATUS_LIST.filter(status => status.text !== 'Tracking').map(filteredStatus => /*#__PURE__*/React.createElement(Menu.Item, {
    key: filteredStatus.text,
    onPress: async () => {
      await handleWatching(filteredStatus.value);
    }
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: filteredStatus.icon
  }), /*#__PURE__*/React.createElement(Text, null, " ", filteredStatus.text))))), /*#__PURE__*/React.createElement(HandlePost, {
    type: type,
    topic: topic,
    reply: reply,
    forceTypeReply: true,
    updateTopicReplies: updateTopicReplies,
    trackForum: trackForum
  }), /*#__PURE__*/React.createElement(MoreActions, {
    topic: topic,
    reply: reply,
    loadContents: loadContents,
    updateTopicPost: updateTopicPost,
    updateForceReloadTopics: updateForceReloadTopics,
    updateTopicReplies: updateTopicReplies,
    forSingleTopicScreen: forSingleTopicScreen,
    trackForum: trackForum
  })));
};
export default InteractionBar;
//# sourceMappingURL=InteractionBar.js.map